export default __webpack_public_path__ + "static/Segment-85f310394dba72dfe376fb260d8c7f9e.png";